// extracted by mini-css-extract-plugin
export var blue = "_17-f";
export var brand = "_17-b";
export var darkGrey = "_17-e";
export var disabled = "_17-4";
export var disabledSubtle = "_17-5";
export var error = "_17-6";
export var green = "_17-g";
export var grey = "_17-d";
export var icon = "_17-0";
export var inherit = "_17-a";
export var lightGrey = "_17-c";
export var orange = "_17-i";
export var pink = "_17-k";
export var primary = "_17-1";
export var purple = "_17-l";
export var red = "_17-j";
export var secondary = "_17-2";
export var success = "_17-9";
export var tertiary = "_17-3";
export var warning = "_17-7";
export var warningSecondary = "_17-8";
export var white = "_17-m";
export var yellow = "_17-h";